import React from 'react';
import { Card } from 'reactstrap';
import './css/TrendingProfileCard.css';
import { ROLE } from '../../shared/constants/common';
import FollowPPVCreatorButton from '../buttons/FollowPPVCreatorButton';
import ViewProfileButton from '../buttons/ViewProfileButton';
import { getSubscriptionPriceWithExtraCharge } from '../../shared/utils/paymentUtil';
import { truncateUsernameDisplay } from '../../shared/utils/usernameFormat';

const TrendingProfileCard = ({
  index,
  profile,
  vatPercentage = 0,
  onFollowSuccess,
  onUnfollowSuccess
}) => {
  return (
    <div className="trending-profile-col">
      <Card className="trending-profile-card">
        <div className="trending-profile-image-container">
          <img
            src={profile.avatar}
            alt={profile.username}
            className="trending-profile-avatar"
          />
          <div className="trending-rank-badge">
            #{index + 1}
          </div>
        </div>
        <h3 className="trending-profile-username">{truncateUsernameDisplay(profile.username)}</h3>
        <div className="trending-profile-info">
          <i className="fa-solid fa-fire trending-fire-icon"></i>
          <span className="trending-profile-status">
            {profile.rol === ROLE.CREATOR_CONTENT ? 'Trending Content' : 'Trending Profile'}
          </span>
        </div>

        {profile.rol === ROLE.CREATOR_SUB && profile.price && (
          <div className="trending-profile-price">
            <span>
              {`${getSubscriptionPriceWithExtraCharge(profile.price, profile?.active_promotion, vatPercentage)}`}
            </span>
          </div>
        )}

        {profile.rol === ROLE.CREATOR_CONTENT && (
          <FollowPPVCreatorButton
            creator={profile}
            onFollowSuccess={onFollowSuccess}
            onUnfollowSuccess={onUnfollowSuccess}
          >
            <button className={`follow-btn ${profile.isFollowing ? 'following' : ''}`}>
              {profile.isFollowing ? 'Following' : 'Follow'}
            </button>
          </FollowPPVCreatorButton>
        )}

        <div className="mt-auto trending-profile-buttons">
          <ViewProfileButton creator={profile}>
            <button className={`cm_outline_primary ${profile.isFollowing ? 'following' : ''}`}>
              View Profile
            </button>
          </ViewProfileButton>
        </div>

      </Card>
    </div>
  );
};

export default TrendingProfileCard;

